import { Component, DestroyRef, inject, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { BinFilteredSamples } from './bin-filtered-samples/bin-filtered-samples';
import { BinUnfilteredSamples } from './bin-unfiltered-samples/bin-unfiltered-samples';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bin-capacity',
  imports: [CommonModule,TranslatePipe,RTLDivDirectiveDirective,FormsModule,BinFilteredSamples,BinUnfilteredSamples],
  templateUrl: './bin-capacity.html',
  styleUrl: './bin-capacity.scss',
})
export class BinCapacity {
  isMobile: boolean;
	translationsObj;
	currentLang;
  isUnfilteredTransmission:boolean = false;
	user_role_id = 0;
	private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery:ApiQuery) {
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();

    this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
			if (!user) return;
      this.user_role_id = user["user_role_id"];
		});
  }

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  unfilteredTransmissionBtn(value){
    this.isUnfilteredTransmission = value;
  }
}
